import { render, staticRenderFns } from "./MobileCardList.vue?vue&type=template&id=637e1ddf"
import script from "./MobileCardList.vue?vue&type=script&lang=js"
export * from "./MobileCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports